import { cloneDeep } from 'lodash-es';
import { freezeDeep } from './helpers/freeze-deep';
import { removeProps } from './helpers/remove-props';
import { BaySpacing, BeamDirection, GenerationType, QuoteData, QuoteReference } from './quote-data';

const quoteDataProps = [
  '__typename',
  'TransportTotal',
  'id',
  'lowerBound',
  'upperBound',
  'Area',
  'TierData.Depth',
  'IsPlant',
  'PostCentres',
  'IsRenderable',
  'AncillaryType',
];

export function QuoteNumber(qf: QuoteReference): string | null {
  return qf ? `${qf.Quote}/${qf.Revision}/${qf.Option}` : null;
}

export function PrepareQuoteDataForSaving(qd: QuoteData, ...additionalProps: string[]): any {
  return removeProps(qd, 'QuoteNumber', ...quoteDataProps, ...additionalProps);
}

export function PrepareQuoteDataForWorker(qd: QuoteData): any {
  return removeProps(qd, ...quoteDataProps);
}

export function GetGenerationType(qd: QuoteData): GenerationType {
  if (qd.FloorData.GridData.BaySpacing === BaySpacing.Economic) {
    return GenerationType.Economic;
  } else if (qd.FloorData.GridData.BeamDirection === BeamDirection.Auto) {
    return GenerationType.Auto;
  }
  return GenerationType.Normal;
}

export function FreezeQuoteData(qd: QuoteData): QuoteData {
  return freezeDeep(qd);
}

export function CloneQuoteData(qd: QuoteData): QuoteData {
  return cloneDeep(qd);
}
